import { gql } from '@apollo/client';
const ADD_AND_ASSIGN_COMPONENTS = gql `
  mutation AddAndAssignComponents(
    $modelSpecificationId: ID!
    $components: [AddAndAssignComponentInput!]!
    $language: String!
  ) {
    addAndAssignComponents(
      modelSpecificationId: $modelSpecificationId
      components: $components
      language: $language
    ) {
      components {
        id
        productCategory {
          id
        }
        productSnapshot {
          product {
            id
          }
        }
      }
    }
  }
`;
export default ADD_AND_ASSIGN_COMPONENTS;
